var React = require('react');

function Dots (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.482.8a10.5 10.5 0 118.036 19.4A10.5 10.5 0 016.482.8zM10.5 3a7.5 7.5 0 100 15 7.5 7.5 0 000-15zM6.482 27.8a10.5 10.5 0 118.036 19.4 10.5 10.5 0 01-8.036-19.4zM10.5 30a7.5 7.5 0 100 15 7.5 7.5 0 000-15zM33.482.8a10.5 10.5 0 118.036 19.4A10.5 10.5 0 0133.482.8zM37.5 3a7.5 7.5 0 100 15 7.5 7.5 0 000-15zm-4.018 24.8a10.5 10.5 0 118.036 19.4 10.5 10.5 0 01-8.036-19.4zM37.5 30a7.5 7.5 0 100 15 7.5 7.5 0 000-15z"}));
}

Dots.defaultProps = {"viewBox":"0 0 48 49"};

module.exports = Dots;

Dots.default = Dots;
